var render = function (_h,_vm) {var _c=_vm._c;return _c('v-btn',{staticClass:"c-base-round-button",attrs:{"color":"#34ebc9","fab":"","disabled":_vm.props.disabled},on:{"click":_vm.listeners.click}},[_vm._t("default",function(){return [_vm._v("+")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }